export default __webpack_public_path__ + "static/media/Background_00203.66b4b7c3.png";